"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _konstructPartData = _interopRequireDefault(require("@traaidmark/konstruct-part-data"));

require("./stylesheet.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Sticker = function Sticker(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? undefined : _ref$label,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? undefined : _ref$value,
      _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? undefined : _ref$prefix,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      rest = _objectWithoutProperties(_ref, ["label", "value", "prefix", "className", "size"]);

  return _react.default.createElement("div", _extends({
    className: "p-sticker p-sticker--".concat(size, " ").concat(className)
  }, rest), label && _react.default.createElement("small", null, label), _react.default.createElement(_konstructPartData.default, {
    value: value,
    prefix: prefix,
    size: size
  }));
};

Sticker.propTypes = {
  label: _propTypes.default.string,
  prefix: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object]),
  size: _propTypes.default.oneOf[('small', 'default', 'large', 'xlarge')],
  className: _propTypes.default.string
};
var _default = Sticker;
exports.default = _default;